import React from "react";
import {
  FaClipboardCheck,
  FaFileImage,
  FaMedal,
  FaPen,
  FaTrophy,
} from "react-icons/fa";
import { GiPodium } from "react-icons/gi";

function StatCard({ icon: Icon, label, value, description }) {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05]">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-amber-700 shadow-sm dark:bg-white/10 dark:text-amber-200">
          <Icon />
        </div>

        <div>
          <p className="text-2xl font-bold text-slate-950 dark:text-white">
            {value}
          </p>
          <p className="text-sm font-bold text-slate-700 dark:text-white/80">
            {label}
          </p>
          {description && (
            <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

function ResultatsStats({ stats }) {
  return (
    <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
      <StatCard
        icon={FaTrophy}
        label="Compétitions"
        value={stats.total}
        description="Événements liés à ton profil"
      />

      <StatCard
        icon={FaClipboardCheck}
        label="Résultats saisis"
        value={stats.withResults}
        description="Avec classement ou détail"
      />

      <StatCard
        icon={FaPen}
        label="À compléter"
        value={stats.withoutResults}
        description="Sans résultat renseigné"
      />

      <StatCard
        icon={GiPodium}
        label="Podiums"
        value={stats.podiums}
        description="Classements 1, 2 ou 3"
      />

      <StatCard
        icon={FaFileImage}
        label="Documents"
        value={stats.withDocuments}
        description="Podium ou tableau ajouté"
      />
    </div>
  );
}

export default ResultatsStats;